/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize PostVaccineAntiHbs View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PostVaccineAntiHbsView';

export const mapStateToPropsPostVaccineAntiHbs = mapStateToProps;
export const mapDispatchToPropsPostVaccineAntiHbs = mapDispatchToProps;

export default connect(
  mapStateToPropsPostVaccineAntiHbs,
  mapDispatchToPropsPostVaccineAntiHbs
)(View);
